import type { IApplicationState } from 'shared/types/redux';

export const selectCPDDraftStatus = (state: IApplicationState) => state.cpd.cpdDraftStatus;
